// CircleProgress.js
export function drawProgress(isShowMeasure, measureWord, canvas, progress) {
    const ctx = canvas.getContext("2d");
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = 100; // 円の半径
    let progressColor;

    // measureWordに応じて色を選択
    if (measureWord === 'pa') {
        progressColor = "#e77f8f";
    } else if (measureWord === 'ta') {
        progressColor = "#56af78";
    } else if (measureWord === 'ka') {
        progressColor = "#1550a3";
    } else {
        progressColor = "#e77f8f";
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // 灰色のプログレスの枠を描画
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
    ctx.strokeStyle = "#EAEAEA";
    ctx.lineWidth = 25; // 枠の太さを調整
    ctx.lineCap = "round"; // 末端に丸みを付ける
    ctx.stroke();

    // ピンク色のプログレスを描画
    if (isShowMeasure) {
        ctx.beginPath();
        // ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
        ctx.arc(centerX, centerY, radius, -Math.PI / 2, (2 * Math.PI * progress) - Math.PI / 2);
        ctx.strokeStyle = progressColor;
        ctx.lineWidth = 15; // プログレスの太さを調整
        ctx.lineCap = "round"; // 末端に丸みを付ける
        ctx.stroke();
    }
}

export function animate(isShowMeasure, measureWord, canvas, durationInSeconds) {
    const framesPerSecond = 60; // 1秒あたりのフレーム数
    const totalFrames = framesPerSecond * durationInSeconds; // 総フレーム数
    const increment = 1 / totalFrames; // プログレスの増加量

    function drawFrame(currentFrame) {
        const progress = currentFrame * increment;
        drawProgress(isShowMeasure, measureWord, canvas, progress);

        if (currentFrame < totalFrames && isShowMeasure) {
            requestAnimationFrame(() => drawFrame(currentFrame + 1));
        }
    }

    drawFrame(0);
}

// プログレスを更新する関数
export function updateProgress(isShowMeasure, measureWord, canvas, startTime, animationDuration) {
    const currentTime = performance.now();
    const elapsedTime = currentTime - startTime;
    const progress = Math.min(1, elapsedTime / animationDuration);

    drawProgress(isShowMeasure, measureWord, canvas, progress);

    if (progress < 1 && isShowMeasure) {
        requestAnimationFrame(() => updateProgress(isShowMeasure, canvas, startTime, animationDuration));
    }
}
